import { AppDownloadContent } from '../../../AppDownloadModal/components/AppDownloadContent';

interface IProps {
  title: string;
}

export const AppDownloadCTA = ({ title = 'See all catches in the Fishbrain app' }: IProps) => {
  return (
    <div className="flex flex-col items-center justify-center bg-sea-foam px-2">
      <AppDownloadContent contentHeader={title} className="max-h-[600px] max-w-[900px]" />
    </div>
  );
};
